import React, { Component } from'react';
import connect from 'react-redux/es/connect/connect';
import { Link } from 'react-router';
import { Layout, Menu, Icon, Avatar } from 'antd';

import { controlSidebar } from '../../../actions/optionsStoreActions';

import icons from '../../icons/icons';

import 'antd/dist/antd.css';
import './sidebar.less';

const { Sider } = Layout;
const logo = 'https://firebasestorage.googleapis.com/v0/b/implant-compare.appspot.com/o/images%2Flogo.png?alt=media&token=424838ed-0422-4212-82f2-dc506dd61579'

class Sidebar extends Component {
  state = {
    configs: [
      {
        // number 0
        key: "/",
        component: icons.home,
        to: "/Channels/",
        title: "Home"
      },
      {
        // number 1
        key: "library",
        title: "Library",
        className: "menu-title",
        simple: true
      },
      {
        // number 2
        key: "/Channels",
        component: icons.channels,
        to: "/Channels/",
        title: "Channels"
      },
      {
        // number 3
        key: "/Surgeries",
        component: icons.surgeries,
        to: "/Past_Events/Surgeries",
        title: "Surgeries"
      },
      {
        // number 4
        key: "/Conferences",
        component: icons.conferences,
        to: "/Past_Events/Conferences",
        title: "Conferences"
      },
      {
        // number 5
        key: "/Webinars",
        component: icons.webinars,
        to: "/Past_Events/Webinars",
        title: "Webinars"
      },
      // {
      //   key: "/UpcomingEvents",
      //   component: icons.upcomingEvents,
      //   to: "/Upcoming_events/",
      //   title: "Upcoming Events"
      // },
      {
        // number 6
        key: "favorites",
        title: "Favorites",
        className: "menu-title",
        simple: true
      },
      {
        // number 8
        key: "/Saved-events",
        component: icons.savedEvents,
        to: "/Saved_events",
        title: "Saved Events"
      },
      {
        // number 9
        key: "/Payments",
        type: "dollar",
        to: "/Payments",
        title: "Purchased Events"
      },
      {
        // number 10
        key: "menu-title",
        className: "menu-title",
        noShown: true,
        simple: true
      },
      {
        // number 11
        key: "/Admin_configuration/1",
        className: "highlight",
        type: "plus",
        to: "/Admin_configuration/1",
        title: "Create Channel",
        noShown: true
      },
      {
        // number 12
        key: "/Admin_configuration/2",
        className: "highlight",
        type: "plus",
        to: "/Admin_configuration/2",
        title: "Create Contributor",
        noShown: true
      },
      {
        // number 13
        key: "/Event_Editor",
        className: "navigation-button",
        to: "/Event_Editor",
        title: "Create Event",
        noShown: true
      },
    ],
    currentKey: '/',
    isMenuCollapsed: false,
    userType: "user"
  };

  static getDerivedStateFromProps(props, state) {
    const { userClaims } = props.user;
    if (userClaims.userType !== state.userType) {
      const updatedConfigs = [...state.configs].map((config, index) => {
        switch(index) {
          case 9:
            return {
              ...config,
              noShown: !userClaims.userType
            };

          case 10:

          case 11:
            return {
              ...config,
              noShown: userClaims.userType !== "Admin"
            };

          case 12:
            return {
              ...config,
              noShown: !userClaims.userType
            };

          default:
            return config;
        }
      });

      return {
        userType: userClaims.userType,
        configs: updatedConfigs
      };
    }

    return null;
  }

  handleChangeMenuKey(e) {
    this.props.changePageHandler({ currentKey: e.key });
  }

  handleMenuToggle() {
    this.setState({
      isMenuCollapsed: !this.state.isMenuCollapsed,
    });
  };

  render() {
    const { data, user, options } = this.props;
    const { subscriptions, channels } = data;
    const { userClaims, uid, userData } = user;
    let subscriptionsNumber = 0;

    subscriptions && uid && Object.keys(subscriptions).forEach(subscription => {
      if (subscription === uid) {
        subscriptionsNumber = subscriptions[subscription].length;
      }
    });
    if (uid && channels && userClaims.userType === 'Admin') {
      subscriptionsNumber = channels.length;
    }

    let loginWidget = (
      <div className="login-links">
        <Link to="/Auth/">Sign In / Sign Up</Link>
      </div>
    );

    if (user && uid) {
      const src = (userData && userData.PhotoUrl) ?
        userData.PhotoUrl : null;

      loginWidget = (
        <Link to={'/profile/'}>
          <div className="user-block">
            <Avatar src={src} size={34} icon="user" />
            <div className="user-block-text">
              <div className="user-block-name">
                {userData ? (userData.DisplayName ? userData.DisplayName : userData.name) : 'Anonymous'}
              </div>
              <div className="user-block-subscriptions">
               {`${subscriptionsNumber} subscriptions`}
              </div>
            </div>
          </div>
        </Link>
      );
    }

    const menuItems = this.state.configs.map(config => {
      if (!config.noShown && config.simple) {
        return (
          <div
            key={config.key}
            className={config.className}
          >
            {config.title ? config.title : null}
          </div>
        )
      }

      if (!config.noShown) {
        return (
          <Menu.Item
            disabled={!!config.disabled}
            key={config.key}
            className={config.className}
          >
            {
              config.component ?
                <Icon component={config.component} /> :
                <Icon type={config.type} />
            }
            <Link to={config.to}>{config.title}</Link>
          </Menu.Item>
        )
      }

      return null
    });

    const userClassName = ["sidebar-user", this.props.currentKey === '/profile' ? 'sidebar-user-active' : ''].join(' ');

    const isMenuCollapsed = options && options.controlSidebar;

    return (
      <Layout
        hasSider={true}
        className={`menu-sidebar ${isMenuCollapsed ? "is-menu-collapsed" : "is-menu-opened"}`}
      >
        <Sider
          width="250"
          breakpoint="lg"
          collapsedWidth="0"
          trigger={null}
          collapsed={isMenuCollapsed}
        >
          <div className="sidebar-header">
            <div className="logo">
              <Link to="/Channels/">
                <img src={logo} width="142" height="22" alt="ImplantCompare" />
              </Link>
            </div>

            <div
              className={`sidebar-menu-trigger ${isMenuCollapsed ? '' : 'active'}`}
              onClick={() => this.props.controlSidebar(true)}
            >
              <Icon type="close" />
            </div>
          </div>

          <Menu
            mode="inline"
            inlineIndent={17}
            className="sidebar-menu"
            selectedKeys={[this.props.currentKey]}
            onClick={(e) => this.handleChangeMenuKey(e)}
          >
            {
              menuItems
            }

            {/*<Menu.Item key="/Messages">*/}
            {/*  <Icon component={icons.messages} />*/}
            {/*  <Link to="/Messages">*/}
            {/*    <div className="message_container">*/}
            {/*      <div className="message_content">*/}
            {/*        Messages*/}
            {/*      </div>*/}
            {/*      {unreadMessage.newMessages && (*/}
            {/*        <div className="unread_messages">*/}
            {/*          {unreadMessage.count > 99 ? '99+' : unreadMessage.count}*/}
            {/*        </div>*/}
            {/*      )}*/}

            {/*    </div>*/}
            {/*  </Link>*/}
            {/*</Menu.Item>*/}

            {/*{*/}
            {/*  menuItems.slice(14) // add Admin_configuration and Create_event*/}
            {/*}*/}

          </Menu>

          <div
            className={userClassName}
            onClick={() => this.handleChangeMenuKey({key: '/profile'})}
          >
            {loginWidget}
          </div>
        </Sider>
      </Layout>
    );
  }
}

export default connect(
  (state) => {
    return { options: state.options };
  },
  { controlSidebar }
)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Modules/Sidebar/index.js